/* =========================================================================
   Penny Premium 3D — hotspots.js
   Shop-the-look product hotspots. A pulsing dot ([data-hotspot]) opens the
   matching mini product popover ([data-hotspot-popover]) inside the same
   tile: focus-trapped, Escape / outside click / close button dismiss.
   Delegated listeners — works after theme-editor section reloads.
   ========================================================================= */

const penny = window.penny;
let openPopover = null;

function close(popover) {
  if (!popover || popover.hasAttribute('hidden')) return;
  popover.setAttribute('hidden', '');
  const dot = popover.closest('[data-hotspot-tile]')?.querySelector(`[aria-controls="${popover.id}"]`);
  dot?.setAttribute('aria-expanded', 'false');
  if (openPopover === popover) openPopover = null;
  penny.releaseFocus();
}

document.addEventListener('click', (event) => {
  const dot = event.target.closest('[data-hotspot]');

  if (dot) {
    const popover = document.getElementById(dot.getAttribute('aria-controls'));
    if (!popover) return;
    if (!popover.hasAttribute('hidden')) {
      close(popover);
      return;
    }
    close(openPopover);
    // Never two popovers at once — also close any open quick-add popover
    document.querySelectorAll('[data-quick-add-popover]:not([hidden])').forEach((p) => {
      p.setAttribute('hidden', '');
      p.closest('[data-quick-add]')
        ?.querySelector('[data-quick-add-toggle]')
        ?.setAttribute('aria-expanded', 'false');
    });
    popover.removeAttribute('hidden');
    dot.setAttribute('aria-expanded', 'true');
    openPopover = popover;
    penny.trapFocus(popover);
    return;
  }

  if (event.target.closest('[data-hotspot-close]')) {
    close(event.target.closest('[data-hotspot-popover]'));
    return;
  }

  if (openPopover && !openPopover.contains(event.target)) {
    close(openPopover);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && openPopover) close(openPopover);
});
